import type { FC } from "react";

import { CustomButton } from "../Button";

interface ActionButtonsProps {
  formID: string;
  click: () => void;
  isStepValid?: boolean;
  isPending?: boolean;
}

const ActionButtons: FC<ActionButtonsProps> = ({
  formID,
  click,
  isStepValid = true,
  isPending = false,
}) => {
  return (
    <div className="flex items-center gap-4.5">
      <CustomButton
        type="button"
        variant="light"
        onClick={click}
        data-testid={`${formID}-cancel-button`}
      >
        Cancel
      </CustomButton>
      <CustomButton
        type="submit"
        form={formID}
        disabled={!isStepValid}
        isPending={isPending}
        data-testid={`${formID}-save-button`}
      >
        Save changes
      </CustomButton>
    </div>
  );
};

export default ActionButtons;
